import {VideoCaption} from "../common/video/models/VideoCaption";
import {UserRole} from "../models/user";
import {isNullorUndefined} from "./ObjectUtils";

export const roles = ["管理者", "コンテンツ編集者", "一般"];

// User権限判定
export function isUser(roles: UserRole[] | undefined) {
    return roles?.length === 0;
}

// Admin権限判定
export function isAdmin(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "ADMIN");
}

// Editor権限判定
export function isEditor(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "EDITOR");
}

// Profesional権限判定
export function isProfessional(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "PRESENTER");
}

// Guest権限判定
export function isGuest(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "GUEST");
}

// UNAVAILABLE権限判定
export function isUnavailable(roles: UserRole[] | undefined) {
    return !!roles?.some((role) => role.role === "UNAVAILABLE");
}

// API実行エラー判定
export function isAxiosError(error: any) {
    return isNullorUndefined(error) ? false : error.isAxiosError;
}

// 指定範囲内の乱数を生成する
export function getRandomInt(min: number, max: number) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1) + min);
}

// パラメータをメッセージに設定する
export function setMessageArgs(str: string, ...args: string[]) {
    let message = str;
    for (let i = 0; i < args.length; i++) {
        message = message.replace(`{${i}}`, args[i]);
    }

    return message;
}

// ビデオ処理ステータス判定
export function getVideoStatus(status: string){
    switch (status.toUpperCase()){
        case "CREATED":
            return "Video処理中";
        case "STORED":
        case "DATA_EXTRACTED":
            return "STT生成中";
        case "SUBTITLES":
            return "サムネイルアップロード中";
        case "THUMBNAILS":
            return "資料アップロード中";
        case "FAILED":
            return "処理失敗";
        case "COMPLETED":
            return "処理完了";
        case "":
            return "準備中";
        default:
            return "ステータス不明";
    }
}

// ビデオ処理進捗値判定
export function getStatusProgress(status: string){
    switch (status.toUpperCase()){
        case "CREATED":
            return 20;
        case "STORED":
            return 50;
        case "DATA_EXTRACTED":
            return 60;
        case "SUBTITLES":
            return 70;
        case "THUMBNAILS":
            return 80;
        case "FAILED":
        case "COMPLETED":
            return 100;
        default:
            return 0;
    }
}

// CaptionをVTTファイルに変換する
export function ConvertCaptionToVtt(fileName: string, captions: VideoCaption[], language?: "ja") {
    let content = "WEBVTT\n\n";
    captions.map((caption) => {
        content += ConvertMsToTimeWithDotMs(caption.startMillis) 
                + " --> " 
                + ConvertMsToTimeWithDotMs(caption.endMillis)
                + "\n" 
                + caption.transcript 
                + "\n\n";
        return null;
    });
    return window.URL.createObjectURL(new File([content], fileName + "." + language + ".vtt", {type: "text/vtt"}));
}
// ミリ秒 ⇒ hh:mi:ss.zzz
export function ConvertMsToTimeWithDotMs(millis: number){
    return stringifyVideoTimeWithColons(millis) + "." + ("000" + millis).slice(-3);
}

export function stringifyVideoTimeWithColons(millis: number, alwaysShowHours?: true) {
    const [hours, minutes, seconds] = millisToHoursMinutesSeconds(millis);

    const hourString = hours < 10 ? `0${hours}` : `${minutes}`;
    const minuteString = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const secondString = seconds < 10 ? `0${seconds}` : `${seconds}`;

    const showHours = hours > 0 || alwaysShowHours;

    return showHours
        ? [hourString, minuteString, secondString].join(":")
        : [minuteString, secondString].join(":");
}

const MILLIS_PER_SECOND = 1000;
const MILLIS_PER_MINUTE = MILLIS_PER_SECOND * 60;
const MILLIS_PER_HOUR = MILLIS_PER_MINUTE * 60;

function millisToHoursMinutesSeconds(millis: number) {
    const wholeHours = Math.floor(millis / MILLIS_PER_HOUR);

    const minuteMillis = millis - wholeHours * MILLIS_PER_HOUR;
    const wholeMinutes = Math.floor(minuteMillis / MILLIS_PER_MINUTE);

    const secondMillis = minuteMillis - wholeMinutes * MILLIS_PER_MINUTE;
    const wholeSeconds = Math.floor(secondMillis / MILLIS_PER_SECOND);

    return [wholeHours, wholeMinutes, wholeSeconds];
}